// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".groupPart[data-v-37aaed4a]{cursor:pointer;padding:10px;background:#eee;border:1px solid #fff;border-radius:8px 8px 0 0}", ""]);
// Exports
module.exports = exports;
